const definitions = {
    'stocker': 'Can view machines and stock.',
    'driver': 'Can view machines and make deliveries.',
    'stocker-driver': 'Can view machines, stock and make deliveries.',
    'admin': 'Can manage machines.',
    'super-admin': 'All access.'
}

export default definitions